import React from 'react';
import {View, TouchableOpacity} from 'react-native';
import {Field} from 'redux-form';
import SafeAreaView from 'react-native-safe-area-view';

import {images} from '../../../../assets/icons';
import {BaseField} from '../../../../shared/components/baseField';
import {Button} from '../../../../shared/components/button';
import {Text} from '../../../../shared/components/text';
import {dateNewsTo} from '../../../../shared/constants/date';
import {useStyles} from '../../../../shared/hooks/styles';
import {useTheme} from '../../../../shared/theme';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {ViewProps} from './model';

export default ({
  formData,
  style,
  closeButton,
  onSubmit,
  onShowAllChange,
  onDateChange,
  onClose,
  ...viewProps
}: ViewProps) => {
  const theme = useTheme();

  const styles = useStyles(({addShadow, mediaOnly}) => ({
    container: {
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.25,
      }),
      borderRadius: 5,
      width: 314,
      height: 276,
      backgroundColor: theme.color.backgroundMenuColor,
      justifyContent: 'space-between',
    },
    btnApply: {
      width: '100%',
      margin: 0,
    },
    checkboxlabel: {
      ...theme.fonts.body,
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    dateField: {
      ...mediaOnly(DeviceSize.mobile, {
        height: 40,
      }),
    },
    padding: {
      paddingHorizontal: 16,
      paddingVertical: 15,
    },
    body: {
      flex: 1,
      borderBottomColor: theme.color.borderColor,
      borderBottomWidth: 1,
      justifyContent: 'space-between',
    },
    buttonClose: {
      margin: -15,
      padding: 15,
    },
    checkbox: {
      paddingVertical: 10,
      marginVertical: -10,
    },
  }));

  return (
    <SafeAreaView style={[styles.container, style]} {...viewProps}>
      <View style={[styles.padding, styles.body]}>
        <View style={styles.header}>
          <Text testID='show-filter-label-id' type='h5Light'>
            Показать
          </Text>
          {closeButton && (
            <TouchableOpacity testID='news-filter-close-button-id' onPress={onClose} style={styles.buttonClose}>
              <images.Close width={22} height={22} color={theme.color.primaryColor} />
            </TouchableOpacity>
          )}
        </View>
        <Field
          name='from'
          type='date'
          props={{maxDate: formData.to, variant: 'outlined', style: styles.dateField}}
          component={BaseField}
          onChange={onDateChange}
        />
        <Field
          name='to'
          type='date'
          props={{minDate: formData.from, maxDate: dateNewsTo, variant: 'outlined', style: styles.dateField}}
          component={BaseField}
          onChange={onDateChange}
        />
        <Field
          type='checkbox'
          component={BaseField}
          name='all'
          label='За все время'
          props={{style: styles.checkbox}}
          onChange={onShowAllChange}
          labelStyle={styles.checkboxlabel}
        />
      </View>
      <View style={styles.padding}>
        <Button id='news-filter-show' type='secondary' text='Показать' style={styles.btnApply} onPress={onSubmit} />
      </View>
    </SafeAreaView>
  );
};
